import {SpyneAppProperties, ViewStream} from 'spyne';
import sdk from "@stackblitz/sdk";
import TicTacSpyne from "imgs/tic-tac-toe-spyne.png";

export class PageDocsItemBlockExternalStackblitz extends ViewStream {
  constructor(props = {}) {
    // props.template = `<p>STACKBLITZ: ${props.data.title}</p>`;
    super(props);
  }

  addActionListeners() {
    // return nexted array(s)
    return [];
  }

  broadcastEvents() {
    // return nexted array(s)
    return [];
  }

  createLinkFromHeading(){
    const {externalId} = this?.props?.data;
    const link = `https://stackblitz.com/edit/${externalId}`;
    const titleEl = this.props.el.parentElement.parentElement.querySelector('.external-title')

    const updateHTML = (html)=>{
      const anchorStart = `<a href=${link} target="_blank" alt="stackblitz">`
      html = html.replace("<p>", anchorStart);
      html = html.replace("</p>", `<svg style="position:relative; top:2px;" viewBox="0 0 28 28" aria-hidden="true" class="_boltIcon_1bpga_9 _boltIcon_blue_1bpga_14" height="18" width="18" xmlns="http://www.w3.org/2000/svg">
  <defs></defs>
  <path style="fill:#2340a3;" d="M12.747 16.273h-7.46L18.925 1.5l-3.671 10.227h7.46L9.075 26.5l3.671-10.227z"></path>
</svg></a>`);

      return html;
    }

    titleEl.innerHTML = updateHTML(titleEl.innerHTML);

  }

  addImgPlaceholder() {
    const { externalId } = this.props.data;

    //console.log("THIS PROPS ITEM IS ",this.props);

    const imgHash = {
      "spyne-toh-example": require("imgs/toh-spyne.png"),
      "spyne-tic-tac-toe": TicTacSpyne,
      "ng-toh-tutorial": require("imgs/toh-ng.png"),
      "stackblitz-react-tic-tac-toe": require("imgs/tic-tac-toe-react.png"),
    };

    const imgSrc = imgHash[externalId];
    const imgView = new ViewStream({
      tagName: "img",
      style: "max-width:initial;",
      src: imgSrc,
    });

    this.appendView(imgView);

    this.createLinkFromHeading();
  }

  embedProject() {
    sdk.embedProjectId(this.props.el, this.props.data.externalId, {
      forceEmbedLayout: true,
      openFile: this.props.data.openFile,
      view: "default",
    });
  }

  onRendered() {
    //this.embedProject();

    this.addImgPlaceholder();


/*    if (SpyneAppProperties.getProp("NODE_ENV")==='development'){
      this.addImgPlaceholder();

    } else {
      const delayAddEmbed = () => this.embedProject();
      window.setTimeout(delayAddEmbed, 5000);
    }*/


  }
}
